import { createSelector } from 'reselect'
import userDataSelector from 'redux/selectors/user/user_data_selector'

export default createSelector(
	[ userDataSelector ],
	userData => userData.productId || '0'
)
